import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CampusTrackService {

 


  constructor(public http: HttpClient){}
  getcampus(){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+"ba07e36a-7a3d-4fc3-804f-cd877527539d",
    });
  
    // return this.http.get(environment.CourseFeeUrl+"/employee/allowedCampus",{headers});
    
    return this.http.get(environment.CourseFeeUrl+"/common/empCampuses",{headers}); 
  }
  getclass(){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+"d54e7582-cbde-4b4d-a5c8-288d2619efdc",
    });
    return this.http.get( environment.CourseFeeUrl+"/campusCourseTrack/classDetails",{headers})
  }
  getcampusdata( campus:any,classid:any,stream:any){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+"d54e7582-cbde-4b4d-a5c8-288d2619efdc",
    });
    return this.http.get(environment.CourseFeeUrl+"/campusCourseTrack/classStreamWiseCCTList?campusId="+campus+"&classId="+classid+"&streamId="+stream,{headers})
  }
  getdetails(data:any){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+"d54e7582-cbde-4b4d-a5c8-288d2619efdc",
    });
    return this.http.get(environment.CourseFeeUrl+"/campusCourseTrack/ctDetails?courseTrackId="+data,{headers})
  }
  getcampussave(payload:any){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+"d54e7582-cbde-4b4d-a5c8-288d2619efdc",
    });
    return this.http.post( environment.CourseFeeUrl+"/campusCourseTrack/saveCCTDetails",payload,{headers})
  }
  getcampuspendinglist(listby:any){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+"d54e7582-cbde-4b4d-a5c8-288d2619efdc",
    });
    return  this.http.get(environment.CourseFeeUrl+"/campusCourseTrack/cctApproval?filterBy="+listby,{headers})
  }
  getcampusapporvallist(APPORVAL:any,data2:any){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+"d54e7582-cbde-4b4d-a5c8-288d2619efdc",
    });
    return  this.http.post(environment.CourseFeeUrl+"/campusCourseTrack/saveCCTApprovalDetails?campusTrackId="+APPORVAL, data2,{headers}) 
     
  }
  getcampuslist(filterParams:any,values1:any){
    const headers = new HttpHeaders({
      'Authorization': 'Bearer '+ '9892631d-dd23-4068-904d-9f3e417a3815',
      'Content-Type':'application/json'
    })
        return this.http.get(environment.CourseFeeUrl+"/campusCourseTrack/cctDetails?campusId="+values1+"&filterBy="+filterParams,{headers})
  }
}
